import React from 'react';

/**
 * OverrideMarker — THE "this figure is an OVERRIDE" pen beside a read-only
 * figure (owner, 2026-10-25: *"maybe a small pen symbol with a overide tool
 * tip if overidden"*). One component for every override on Manage Budgets: the
 * crew row's weekly rate, and the grade / member Hourly rate.
 *
 * 🔑 IT IS THE SOLE CARRIER of "overridden", so it follows the
 * `OrderAttachmentMarker` device: `role="img"` + an `aria-label` and a native
 * `title` built from ONE string (the caller's sentence), so the tooltip and the
 * screen reader cannot drift. Render it ONLY while an override is in force —
 * the caller decides that from the SERVER's resolved source, never re-derived.
 *
 * 🎨 `text-[#6b7280] dark:text-gray-300` — a non-text glyph, so WCAG 1.4.11's
 * 3:1 applies. MEASURED in the real build (computed colour on the resolved
 * background, 2026-10-25): light #6b7280 on #ffffff 4.83:1, on a hovered
 * expanded row's #e5e7eb 3.9:1. 🪤 It was `text-gray-500 dark:text-gray-400`
 * and FAILED in dark on a hovered expanded row (#9ca3af on #475569 = 2.98:1) —
 * and `dark:` could not lift it, because `index.css` forces
 * `html.dark .text-gray-500` with `!important`. Hence the ARBITRARY light
 * value (gray-500's own hex, which no override reaches) and gray-300 in dark.
 * jsdom proves none of this.
 * `shrink-0`: it sits beside a figure in a narrow right-aligned cell, and the
 * figure — never the marker — is what may give way.
 */
export default function OverrideMarker({ title, testId, className = '' }) {
  return (
    <span
      role="img"
      aria-label={title}
      title={title}
      data-testid={testId}
      className={`inline-flex items-center shrink-0 text-[#6b7280] dark:text-gray-300 ${className}`.trim()}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-3.5 w-3.5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
        focusable="false"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6.732-6.732a2.5 2.5 0 113.536 3.536L12.536 16.536 9 17l.464-3.536z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 20h16" />
      </svg>
    </span>
  );
}
